import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { fetchNickNameAction } from '../../apiActions/fetchNickNameAction';

import type { NickNameInfoProps } from './types';

const initialState: {
  isNickNameEditOpen: boolean;
  nickNameInfo: NickNameInfoProps;
} = {
  isNickNameEditOpen: false,
  nickNameInfo: {
    error: 0,
    isNickNameInfoFetched: false,
    maxCount: 0,
    remainingAttempts: 0,
    screenName: '',
    showNickNameSection: false,
  },
};

export const nickNameInfoSlice = createSlice({
  name: 'nickNameInfo',
  initialState,
  reducers: {
    setIsNickNameEditOpen: (state, action: PayloadAction<boolean>) => {
      state.isNickNameEditOpen = action.payload;
    },
    setNickNameInfo: (state, action: PayloadAction<object>) => {
      state.nickNameInfo = { ...state.nickNameInfo, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNickNameAction.fulfilled, (state, action) => {
        const showNickNameSection = Number(action.payload?.error) === 0;
        const remainingAttempts = action.payload.maxCount - action.payload.count;
        const isNickNameInfoFetched = true;
        state.nickNameInfo = {
          ...state.nickNameInfo,
          ...action.payload,
          ...{ remainingAttempts, showNickNameSection, isNickNameInfoFetched },
        };
      })
      .addCase(fetchNickNameAction.rejected, (state) => {
        const showNickNameSection = false;
        state.nickNameInfo = {
          ...state.nickNameInfo,
          ...{ showNickNameSection },
        };
      });
  },
});

export const nickNameInfoActions = nickNameInfoSlice.actions;
